<script>
export default {
  name: 'LoadingIndicator',

  functional: true,

  render (h, { data, children }) {
    return <div class="vue-ui-loading-indicator" {...data}>
      <div class="animation" />
      {children}
    </div>
  },
}
</script>

<style lang="stylus" scoped>
$vue-ui-gray-800    = #2c3e50
$vue-ui-primary-500 = #CF0920
$vue-ui-accent-500  = #a44cf6
$vue-ui-white       = #ffffff

colors($color)
  border-color rgba($color, .1)
  border-right-color $color

.vue-ui-loading-indicator
  display flex
  flex-direction column
  align-items: center;
  justify-content: center;
  &.inline
    display inline-flex

  > .animation
    animation rotating .7s linear infinite
    width 1.6rem
    height @width
    border-radius 50%
    border transparent 0.2rem solid
    colors($vue-ui-gray-800)
  &.primary
    > .animation
      colors($vue-ui-primary-500)

  &.white
    > .animation
      colors($vue-ui-white)

  &.accent
    > .animation
      colors($vue-ui-accent-500)
  &.small
    > .animation
      width 1rem
      height @width
  &.big
    > .animation
      width 4rem
      height @width
      border-width 0.3rem

  .vue-ui-high-contrast &
    > .animation
      border-width 0.4rem

  &.overlay
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    z-index 1
    > .animation
      margin-bottom 3.2rem
    &:not(.transparent)
      background rgba($vue-ui-white, .95)
    &.fixed
      position fixed

@keyframes rotating
  0%
    transform rotate(0)
  100%
    transform rotate(360deg)
</style>
